import React from 'react';
import styles from './WarningText.module.css';
import PropTypes from 'prop-types';

const WarningText = ({ text }) => {
  return <div className={styles.warningText}>⚠️ {text}</div>;
};

WarningText.propTypes = {
  text: PropTypes.string,
};

export default WarningText;
